import { setOptOut } from '@amplitude/analytics-browser';

const onRevoke = (): void => {
  if (typeof window !== 'undefined') {
    setOptOut(true);
  }
};

export default onRevoke;
